module.exports = __webpack_public_path__ + "img/1.58b742c5.png";